/** WMO weather-code → label + icon mapping (Open-Meteo). */
import {
  Sun, Moon, CloudSun, CloudMoon, Cloud, CloudFog, CloudDrizzle,
  CloudRain, CloudRainWind, Snowflake, CloudLightning, CloudHail,
} from "lucide-react";

export function weatherInfo(code, isDay = 1) {
  const Day = isDay ? Sun : Moon;
  const DayPart = isDay ? CloudSun : CloudMoon;
  switch (true) {
    case code === 0:
      return { label: "Clear sky", Icon: Day };
    case code === 1:
      return { label: "Mostly clear", Icon: DayPart };
    case code === 2:
      return { label: "Partly cloudy", Icon: DayPart };
    case code === 3:
      return { label: "Overcast", Icon: Cloud };
    case code === 45 || code === 48:
      return { label: "Fog", Icon: CloudFog };
    case code >= 51 && code <= 57:
      return { label: "Drizzle", Icon: CloudDrizzle };
    case code >= 61 && code <= 67:
      return { label: "Rain", Icon: CloudRain };
    case code >= 71 && code <= 77:
      return { label: "Snow", Icon: Snowflake };
    case code >= 80 && code <= 82:
      return { label: "Showers", Icon: CloudRainWind };
    case code === 85 || code === 86:
      return { label: "Snow showers", Icon: CloudHail };
    case code >= 95:
      return { label: "Thunderstorm", Icon: CloudLightning };
    default:
      return { label: "—", Icon: Cloud };
  }
}
